/* Open the existing accessible theme drawer; keep native /cart links as fallback. */
(function () {
  // Cart refresh can replace nodes or morph the existing node's attributes.
  // Persist only shopper clicks, never the server's default open state.
  var upsellKey = 'pg-cart-upsells-open', upsellOpen = null;
  try {
    var saved = localStorage.getItem(upsellKey);
    if (saved === 'true' || saved === 'false') upsellOpen = saved === 'true';
  } catch (_) { /* Keep the choice in memory when storage is unavailable. */ }
  function restoreUpsells(root) {
    if (upsellOpen === null) return;
    function restore(offers) { if (offers.open !== upsellOpen) offers.open = upsellOpen; }
    if (root.matches?.('[data-cart-upsells]')) restore(root);
    root.querySelectorAll?.('[data-cart-upsells]').forEach(restore);
  }
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-cart-upsells] > summary');
    if (!summary || event.defaultPrevented) return;
    upsellOpen = !summary.parentElement.open;
    try { localStorage.setItem(upsellKey, String(upsellOpen)); } catch (_) {}
  }, true);
  restoreUpsells(document);
  new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      if (change.type === 'attributes') restoreUpsells(change.target);
      change.addedNodes.forEach(function (node) { restoreUpsells(node); });
    });
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['open']});
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pg-cart-open]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (window.theme?.settings?.cartType !== 'modal') return;
    var store = window.Alpine?.store('modals');
    if (!store?.isRegistered('cart')) return;
    event.preventDefault(); store.closeAll(); store.open('cart');
  });
  // Prevent checkout while the native theme is refreshing quantities.
  function busy(value) {
    document.querySelectorAll('.pg-cart-checkout').forEach(function (button) {
      button.disabled = value;
      button.setAttribute('aria-busy', String(value));
    });
  }
  var focusTarget, changedInput;
  document.addEventListener('change', function (event) {
    changedInput = event.target.matches('.pg-cart [data-cart-action="quantity"]') ? event.target : null;
  }, true);
  document.addEventListener('shapes:cart:lock', function () {
    var active = document.activeElement;
    if (!active?.closest('.pg-cart-item')) active = changedInput;
    changedInput = null;
    var line = active?.closest('.pg-cart-item');
    focusTarget = line ? { key: line.dataset.lineItemKey, action: active.dataset.cartAction } : null;
    busy(true);
  });
  document.addEventListener('shapes:cart:unlock', function () {
    busy(false);
    var target = focusTarget;
    focusTarget = null;
    if (!target?.action) return;
    requestAnimationFrame(function () {
      var active = document.activeElement;
      // Do not move focus if the shopper has already moved to another control.
      if (active !== document.body && !active?.closest('.pg-cart-item') && active?.id !== 'right-drawer-slot') return;
      var line = Array.from(document.querySelectorAll('.pg-cart-item')).find(function (el) { return el.dataset.lineItemKey === target.key; });
      var next = line?.querySelector('[data-cart-action="' + target.action + '"]:not(:disabled)') || line?.querySelector('input') || document.querySelector('.pg-cart-item input, .pg-cart-empty a');
      next?.focus({ preventScroll:true });
    });
  });
})();
